<template>
  <UiSmartLink
    class="feature-banner body-m"
    :to="urlPath"
    :target="isOpenInNewTab ? '_blank' : null"
  >
    <div class="feature-banner-container">
      <div class="feature-banner-content">
        <p class="feature-banner-title display-m">{{ title }}</p>

        <span v-if="subtitle" class="feature-banner-subtitle"
          >{{ subtitle }}
        </span>

        <UiMiniButton
          v-if="ctaText"
          class="feature-banner-cta"
          :text="ctaText"
          :url="urlPath"
          :is-new-tab="isOpenInNewTab"
        />
      </div>
      <UiSmartImage
        v-bind="smartImageAttributes"
        class="feature-banner-image"
      />
    </div>
  </UiSmartLink>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import UiMiniButton from '@sephora-asia/ui-mini-button'
import UiSmartLink from '@sephora-asia/ui-smart-link'
import UiSmartImage, {
  type PropsSmartImage,
} from '@sephora-asia/ui-smart-image'
import type { PropsFeatureBanner } from './types'

const props = withDefaults(defineProps<PropsFeatureBanner>(), {
  textColor: 'var(--color-base-black)',
  backgroundColor: '',
  ctaText: '',
  urlPath: '',
  subtitle: '',
})

const smartImageAttributes = computed(
  (): PropsSmartImage => ({
    ...props.image,
    aspectRatio: '21/9',
  })
)
</script>
<style lang="scss" scoped>
.feature-banner {
  color: v-bind(textColor);
  text-decoration: none;

  &-container {
    display: flex;
  }

  &-image {
    flex: 1 0 50%;
  }

  &-content {
    flex: 1 0 50%;
    line-height: 150%;
    padding: 24px 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: v-bind(backgroundColor);
  }

  &-cta {
    width: fit-content;
  }

  &-title {
    margin-bottom: 4px;
    @include lineclamp(2);
  }

  &-subtitle {
    margin-bottom: 8px;
    @include lineclamp(4);
  }

  @include media(mobile, tablet) {
    &-container {
      flex-direction: column-reverse;
    }

    &-content {
      padding: 24px 16px;
    }
  }
}
</style>
